export default __webpack_public_path__ + "static/media/quote-1.838c58a5.webp";